"use strict";

const MainMap = function () {
  var setUpListeners = function () {
    Tabs.startListening();
    DataViewDropdown.startDataViewDropdownListeners();
    YearDropdown.startYearDropdownListeners();
    LayerDropdown.startLayerDropdownListeners();
    $(window).on("resize", CommonMapFunctions.invalidateSize);
  };

  var _hideDataImportBasedOnRole = function () {
    if (Session.isFieldPersonnel()) {
      $(".data-import-disabled-link").removeClass("disabled");
      $(".data-import-disabled-link").addClass("hide-option");
    }
  };

  var zoomToCatchmentView = function () {
    var mapLayers = TreeUpdates.getCurrentMapLayers();
    var map = TreeUpdates.getCurrentMap();
    var selectedCatchment = Tree.get(["selected", "catchment"]);

    if (map && mapLayers && mapLayers.catchmentLayer) {
      mapLayers.catchmentLayer.eachLayer(function (layer) {
        if (layer.feature.properties.catchid === selectedCatchment) {
          map.fitBounds(layer.getBounds());
          return;
        }
      });
    }
  };

  var zoomToDrainageView = function () {
    var mapLayers = TreeUpdates.getCurrentMapLayers();
    var map = TreeUpdates.getCurrentMap();
    var catchmentsInDrainage = [];
    var selectedDrainage = Tree.get(["selected", "urbanDrainage"])[0];

    if (map && mapLayers && mapLayers.catchmentLayer) {
      mapLayers.catchmentLayer.eachLayer(function (layer) {
        if (layer.feature.properties.drains_to_c === selectedDrainage) {
          catchmentsInDrainage.push(layer);
        }
      });
      var catchLayerGroup = L.featureGroup(catchmentsInDrainage);
      map.fitBounds(catchLayerGroup.getBounds());
    }
  };

  return {
    zoomToCatchmentView,
    zoomToDrainageView,
    setUpListeners,
    _hideDataImportBasedOnRole,
  };
};

module.exports = MainMap();

const CommonMapFunctions = require("./commonMapFunctions");
const DataViewDropdown = require("./dataViewDropdown");
const LayerDropdown = require("./layerDropdown");
const Tabs = require("../tabs");
const Tree = require("../../tree");
const TreeUpdates = require("./treeUpdates");
const YearDropdown = require("./yearDropdown");
const Session = require("../../login/session");
